<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-close grow" @click="$store.commit('hideReferProgram')">
            <i class="material-icons">close</i>
          </div>

          <template>
            <div class="modal-title">Refer &amp; Earn</div>

            <div class="refer-link">
              <div class="refer-url-container">
                <div class="refer-label">Your Link To Share</div>
                <input
                  type="text"
                  readonly
                  class="refer-url"
                  :value="shareLink"
                  onClick="this.select();"
                />
                <div class="refer-url-more">
                  Your friends will receive
                  <span class="bold">15% off</span> when they use this link.
                  <br />You will receive
                  the reward you choose below after their
                  <span
                    class="bold"
                  >first payment</span>.
                </div>
              </div>
              <div class="refer-copy-icon" @click="copyLink">
                <i class="material-icons">link</i>
              </div>
              <div class="refer-copy-tool" @click="copyLink">Copy</div>
            </div>

            <div class="reward-heading">Choose Your Reward</div>

            <div class="reward">
              <div
                class="reward-option reward-option-snaps"
                :class="{'reward-selected': selected === 'snaps'}"
                @click="selectOption('snaps')"
              >
                <img src="/images/icons/snap.svg" class="snaps-icon" />
                <div class="points">2,000 snaps</div>
              </div>
              <div
                class="reward-option reward-option-credit"
                :class="{'reward-selected': selected === 'credit'}"
                @click="selectOption('credit')"
              >
                <div class="credit">$8 off next month</div>
              </div>
            </div>

            <div class="reward-summary">{{ message }} Thank you!</div>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Back from "../../modules/Back";
import Bus from "../../modules/Bus";
import { mapState } from "vuex";

export default {
  name: "ReferProgram",
  components: {},
  data: function() {
    return {
      selected: null,
      shareLink: null
    };
  },
  computed: {
    ...mapState({
      user: "user"
    }),
    message() {
      if (this.selected === "snaps") {
        return "You'll receive 2,000 snaps for each referral.";
      }
      if (this.selected === "credit") {
        return "You'll receive $8 off your next month for each referral.";
      }
    }
  },
  created() {},
  mounted() {
    // console.log("mounted refer", this.user, this.user.referOption);
    this.selected = this.user.referOption || "snaps";
    this.shareLink = "https://pubby.co/?invite=" + (this.user.id + 2000);
  },
  methods: {
    async selectOption(value) {
      this.selected = value;

      const response = Back.saveReferOption(value);
      if (!response) {
        value = "snaps";
        this.selected = value;
        this.$toasted.show(
          "Oops! Something went wrong. Please try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 3000
          }
        );
        return;
      }

      this.$toasted.show("Saved! " + this.message, {
        icon: "check_circle",
        position: "bottom-center",
        duration: 2000
      });
    },
    copyLink() {
      copyToClipboard(this.shareLink);

      const command = isMacintosh() ? "Command+V" : "Ctrl+V";

      let message = "";

      message =
        "Your link is copied! You can paste it (" +
        command +
        ") anywhere to share it (email, Twitter, etc.)!";

      this.$toasted.show(message, {
        icon: "link",
        position: "bottom-center",
        duration: 6000
      });
    }
  }
};

function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // IE specific code path to prevent textarea being shown while dialog is visible.
    return clipboardData.setData("Text", text);
  } else if (
    document.queryCommandSupported &&
    document.queryCommandSupported("copy")
  ) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy"); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }
}

function isMacintosh() {
  return navigator.platform.indexOf("Mac") > -1;
}
</script>

<style lang="scss" scoped>
.refer-link {
  display: flex;
  justify-content: center;
  padding: 20px 0 40px 0;
}
.refer-label {
  color: $color-blue;
  font-size: 15pt;
  font-weight: 700;
  padding: 0.55em 0.75em;
}
.refer-url {
  width: 520px;
  border: 2px solid darken(#e3f2fd, 10%);
  border-radius: 4px;
  padding: 0.5em 1em;
  font-size: 14pt;
  color: darken(#e3f2fd, 50%);
  background: lighten(#e3f2fd, 4%);
  outline: none;
}
.refer-url-more {
  width: 500px;
  padding: 6px 0 6px 20px;
  font-size: 12pt;
  color: #111;
}
.refer-copy-icon {
  font-size: 17pt;
  padding: 2.85em 0.3em 0 1em;
}
.refer-copy-tool {
  font-size: 15pt;
  padding: 3.1em 0em 0em 0em;
}
.refer-copy-icon:hover,
.refer-copy-tool:hover {
  cursor: pointer;
  opacity: 0.7;
}

.reward-heading {
  text-align: center;
  font-size: 17pt;
  color: #111;
}
.reward {
  display: flex;
  justify-content: center;
  padding: 0px;
}
.reward-label {
  color: $color-blue;
  font-size: 15pt;
  font-weight: 700;
  padding: 0.5em 0.75em;
}
.reward-option {
  width: 198px;
  margin: 20px 8px;
  padding: 16px 20px;
  border: 2px solid #eee;
  border-radius: 8px;
  font-size: 13pt;
  font-weight: 500;
}
.reward-option:hover {
  background: #fff;
  border: 2px solid #ddd;
  cursor: pointer;
}
.reward-option-snaps.reward-selected {
  border: 2px solid lighten($color-snaps, 25%);
}
.reward-option-credit.reward-selected {
  border: 2px solid lighten(#4caf50, 25%);
}
.reward-selected {
  border: 2px solid #e3e3e3;
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.1);
}
.reward-summary {
  padding-bottom: 60px;
  text-align: center;
  font-size: 12.5pt;
  color: #111;
}

.snaps-icon {
  float: left;
  width: 24px;
  margin: 9px 2px 0 12px;
}
.points-icon {
  float: left;
  color: $color-snaps;
  font-size: 18pt !important;
}
.points {
  float: left;
  margin-top: -0px;
  padding-top: 0px !important;
  color: darken($color-snaps, 0%);
  margin-left: 5px;
  font-size: 14.5pt !important;
  font-weight: 600;
  font-family: "Source Sans Pro";
}
.credit {
  float: left;
  margin-top: -0px;
  padding-top: 0px !important;
  color: #4caf50;
  margin-left: 5px;
  font-size: 14.5pt !important;
  font-weight: 600;
  font-family: "Source Sans Pro";
}

.modal-title {
  border-bottom: 1px solid #e3e3e3;
  padding: 0.5em;
  padding-left: 60px;
  font-size: 21pt;
  font-weight: 500;
  color: #111;
  text-align: center;
}
.modal-instructions {
  font-size: 12pt;
  color: #111;
  text-align: center;
}
.modal-limit-instructions {
  padding: 60px 120px;
  font-size: 13.5pt;
  color: #111;
  text-align: center;
}
.modal-close {
  font-size: 15pt;
  margin-top: 10px;
  margin-right: 16px;
  padding: 7px 0 0 6.5px;
  width: 36px;
  height: 36px;
  border-radius: 100px;
  float: right;
  position: relative;
  transition: all 0.2s ease-in-out;
}
.modal-close:hover {
  background: #eee;
  transform: scale(1.1);
  cursor: pointer;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  z-index: 100000;
}

.modal-container {
  z-index: 999999;
  max-width: 1160px;
  min-height: 490px;
  margin: 0px auto;
  padding: 8px 0px 12px 0px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.19);
  transition: all 0.3s ease;
  font-family: "Source Sans Pro";
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

@media (max-width: 1024px) {
  .modal-mask {
    position: absolute !important;
  }
  .modal-container {
    height: auto;
    width: 100%;
    max-width: 100%;
    padding: 20px 0;
  }

  .modal-title {
    text-align: left;
    font-size: 19pt;
    padding-top: 1px;
    padding-left: 18px;
    padding-right: 0;
  }

  .modal-close {
    float: right !important;
    position: initial !important;
    margin-right: 12px !important;
  }
}

.hang-arrow {
  float: left;
  width: 50px;
  padding: 120px 0 0 0;
  text-align: center;
}
.hang-arrow-right {
  float: right;
}
.hang-arrow-i {
  font-size: 48px;
  color: #111;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.bold {
  font-weight: 600 !important;
}
</style>


